export const sqftToAcres = sqft => {
  const dbl = parseFloat(sqft)

  return dbl * 0.0000229568
}
